
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout",
      function () {
        return require("private-next-pages/checkout/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout"])
      });
    }
  